// 阿拉伯语(Arabic)
export default {
  oneOneClass: "",
  learnPracEnFast: "",
  htOralClass: "",
  benefits: "",
  topicNumber: "",
  dailyBusinessAcademic: "",
  englishTutors: "",
  qualifiedTutors: "",
  nativeOkAllAges: "",
  oneOneLive: "",
  accessToRecord: "",
  personalizedPlan: "",
  ensureGoal: "",
  professional: "",
  nativeTeam: "",
  authenticLanguage: "",
  bgChecked: "",
  experiencedTeachers: "",
  assuredQuality: "",
  regularAssess: "",
  assuredSatisfaction: "",
  teamSizeAndRefund: "",
  curriculum: "",
  dailyTalks: "",
  beginnerInfo: "",
  lessonOverview: "",
  beginnerClassIntro: "",
  topicEx: "",
  beginnerTopicEx: "",
  mediateInfo: "",
  mediateClassIntro: "",
  mediateTopicEx: "",
  advancedInfo: "",
  advancedClassIntro: "",
  advancedTopicEx: "",
  businessLanguage: "",
  busElementInfo: "",
  busElementClassIntro: "",
  busElementTopicEx: "",
  busMediateInfo: "",
  busMediateClassIntro: "",
  busMediateTopicEx: "",
  ielts: "",
  languageTests: "",
  aHundredLessons: "",
  ieltsClassIntro: "",
  faq: "",
  questionCn: "",
  classLength: "",
  classInfoAndSuggest: "",
  lessonForm: "",
  lessonFormInfo: "",
  lessonPrepare: "",
  lessonPrepareInfo: "",
  support: "",
  limitedOffer: "",
  originalPrice: "",
  bookNow: "",
  successPurchase: "",
  trialEndAndGoOn: "",
  courseAdvisor: "",
  oneLastStep: "",
  ticketPrice: "",
  perPriceAndOrder: "",
  noThanks: "",
  unpaidAndProceed: "",
  halfPrice: "",
  languageEn: "",
  languageKo: "",
  languageEsp: "",
  languageFr: "",
  languageIt: "",
  languageRu: "",
  languageCn: "",
  languageJp: "",
  courseEn: "",
  courseKo: "",
  courseEsp: "",
  courseFr: "",
  courseIt: "",
  courseRu: "",
  courseCn: "",
  courseJp: "",
  enTestEn: "IELTS",
  koTestEn: "TOPIK",
  espTestEn: "DELE",
  frTestEn: "DELF/DEAL/TE",
  itTestEn: "CILS",
  ruTestEn: "ТРКИ",
  jpTestEn: "JLPT",
  cnTestEn: "HSK",
  coinSpecialOffer: "عرض خاص لإعادة شحن كوين HT",
  buySomeAndGetExtra: "اشتري البعض واحصل على المزيد!",
  balance: "التوازن",
  coins: "{number} كوينات",
  coin: "{number} كوين",
  extraCoins: "{number} كوينات إضافية",
  continue: "متابعه",
  byToppingUpYouAgree: "بإعادة الشحن، فإنك توافق على الاتفاقية",
  topUpAgreement: "[اتفاقية إعادة الشحن]",
  htCoin: "HT كوين",
  scanCodeToLog: "مسح رمز الدخول",
  bindYourHelloTalkAccount:
    "استخدم تطبيق Hello Talk لمسح الرمز وتسجيل الدخول. أربط حساب Hello Talk الخاص بك وأعد شحن الرصيد.",
  itemSelection: "اختيار العنصر",
  paymentAmount: "الكميه",
  topUpSuccessful: "👏إعادة الشحن بنجاح",
  totalCoinsNumber:
    "نجحت في إضافة {numberone} كوينات واستلمت {numbertwo} كوينات إضافية، بإجمالي {numberall} كوينات.",
  ok: "OK",
  copyLinkToPay: "يرجى نسخ الرابط وفتحه باستخدام تطبيق HelloTalk لإكمال الدفع.",
  paymentFailed: "فشل الدفع",
  creditCardPay: "الدفع باستخدام PayPal أو بطاقة الائتمان",
  creditCard: "بطاقة الائتمان",
};
